import moment from 'moment';
import React from 'react';
import { MatchVm } from '../../utils/api';
import { ClubSummary, goalDifference, MatchResult, perGame } from './insightsClubSummary';

interface Props {
    summary: ClubSummary;
    nextMatch?: MatchVm;
    loading: boolean;
    scopeLabel: string;
}

/** Season standing strip. Last-match review lives in InsightsLastMatchPanel. */
const InsightsClubSummaryPanel: React.FC<Props> = ({ summary, nextMatch, loading, scopeLabel }) => (
    <section className="insightsPanel">
        <div className="insightsPanelHead">
            <h2>Season so far</h2>
            <span>{scopeLabel}</span>
        </div>

        {loading && <p className="insightsSummaryMuted">Loading...</p>}

        {!loading && nextMatch && (
            <p className="insightsSummaryMeta insightsSummaryNext">
                Next: {nextMatch.homeTeamDisplayName} vs {nextMatch.awayTeamDisplayName || 'TBD'}
                {nextMatch.startDate
                    ? ` · ${moment(nextMatch.startDate).format('DD MMM YYYY HH:mm')}`
                    : ''}
            </p>
        )}

        <div className="insightsSummaryStats">
            <div className="insightsStat">
                <b>
                    {summary.wins}-{summary.draws}-{summary.losses}
                </b>
                <i>W-D-L</i>
            </div>
            <div className="insightsStat">
                <b>
                    {summary.goalsFor}:{summary.goalsAgainst}
                </b>
                <i>Goals</i>
            </div>
            <div className="insightsStat">
                <b>
                    {goalDifference(summary) > 0 ? '+' : ''}
                    {goalDifference(summary)}
                </b>
                <i>Diff</i>
            </div>
            <div className="insightsStat">
                <b>{perGame(summary.goalsFor, summary.played)}</b>
                <i>Goals / game</i>
            </div>
            <div className="insightsStat">
                <b>{perGame(summary.goalsAgainst, summary.played)}</b>
                <i>Conceded / game</i>
            </div>
            <div className="insightsStat">
                <div className="insightsFormRow">
                    {summary.form.length === 0 && <b>-</b>}
                    {summary.form.map((result: MatchResult, index: number) => (
                        <span
                            // Form is a fixed newest-first slice, so index is a stable key here.
                            key={`${result}-${index}`}
                            className={`insightsFormPip is-${result.toLowerCase()}`}
                        >
                            {result}
                        </span>
                    ))}
                </div>
                <i>Form (newest first)</i>
            </div>
        </div>
    </section>
);

export default InsightsClubSummaryPanel;
